module.exports = __webpack_public_path__ + "5fb34cfcedc9a80023ff5cd7f7702326.fbx";